(ns common.map
  (:require
   [common.filter-controls :as filter-controls]
   [lambdaisland.uri       :as uri]
   [opengb.color           :as color]))

(def CITY-ZOOM 11.5)

(def BUILDING-ZOOM 13)

(defn make-color-by-percentile-expression
  "Creates a maplibre style expression that returns a hex color based on the
  property at provided rank-key and a ramp. Categories are based on
  groups of 20%.

  The strict `<` cutoffs put a rank sitting exactly on a band edge into the
  better (higher-rank) band. `backend.views.current-performance/percent->bar-color`
  colours the performance chart off the same ramp and MUST round on-boundary
  values the same way, or a home on a bucket edge reads a different band on the
  chart than on the map."
  [rank-key ramp]
  (let [[best c2 c3 c4 worst] ramp]
    ["let"
     "rank_num" ["to-number" ["get" rank-key] 0]
     ["case"
      ["<" ["var" "rank_num"] 0.2] worst
      ["<" ["var" "rank_num"] 0.4] c4
      ["<" ["var" "rank_num"] 0.6] c3
      ["<" ["var" "rank_num"] 0.8] c2
      best]]))

(defn make-color-by-year-expression
  "Creates a maplibre style expression that returns a hex color based on the
  year and a color-index. Categories are based on groups
  of ~20 years."
  [color-index]
  ["let"
   "rank_num" ["to-number" ["get" "year"] 0]
   ["case"
    ["<" ["var" "rank_num"] 1940] (color/single ::color/red color-index)
    ["<" ["var" "rank_num"] 1960] (color/single ::color/orange color-index)
    ["<" ["var" "rank_num"] 1980] (color/single ::color/yellow color-index)
    ["<" ["var" "rank_num"] 2000] (color/single ::color/teal color-index)
    (color/single ::color/blue color-index)]])

(defn- make-map-tiles-url
  "All data served by the map tiles server is intended to be public,
   so we can just pass the tenant id as a query param to filter for tenant-specific data.
   No authorization checks occur on the map tile server backend."
  [{:keys [tenant-id buildings-tiles-url]} params]
  (let [query-str (-> params
                      (assoc :tenant_id tenant-id)
                      (uri/map->query-string))]
    (-> buildings-tiles-url
        (uri/uri)
        (assoc :query query-str)
        uri/uri-str)))

(defn filters->url
  "Constructs the map tiles url with current filters applied."
  [url-cfg current-filters]
  (make-map-tiles-url url-cfg (filter-controls/filters->params current-filters)))

(defn selection->url
  "Constructs the map tiles url with a building selected."
  [url-cfg selected-building]
  (make-map-tiles-url url-cfg {:uuid selected-building}))

(defn ->all-buildings-url
  "Constructs the 'all buildings' map tiles url"
  [url-cfg]
  (make-map-tiles-url url-cfg {}))
